import { CANVAS_BRUSH_WIDTH_XXS, CANVAS_BRUSH_WIDTH_XS, CANVAS_BRUSH_WIDTH_S, CANVAS_BRUSH_WIDTH_M, CANVAS_BRUSH_WIDTH_L, CANVAS_PIXEL_ERASER_WIDTH_S, CANVAS_PIXEL_ERASER_WIDTH_M, CANVAS_PIXEL_ERASER_WIDTH_L } from '@asset/constants/canvas';
export let SolvingResult = /*#__PURE__*/function (SolvingResult) {
  SolvingResult["CORRECT"] = "correct";
  SolvingResult["WRONG"] = "wrong";
  SolvingResult["NOT_KNOW"] = "not-know";
  return SolvingResult;
}({});
export let SolvingStatus = /*#__PURE__*/function (SolvingStatus) {
  SolvingStatus["NOT_SOLVED"] = "not-solved";
  SolvingStatus["SOLVED"] = "solved";
  SolvingStatus["NOT_UNDERSTAND"] = "not-understand";
  SolvingStatus["WAIT"] = "wait";
  SolvingStatus["TAKING_EXPLANATION"] = "taking-explanation";
  return SolvingStatus;
}({});
export let StudyStep = /*#__PURE__*/function (StudyStep) {
  StudyStep["FIRST_SOLVING"] = "first-solving";
  StudyStep["SECOND_SOLVING"] = "second-solving";
  StudyStep["TAKING_LECTURE"] = "taking-lecture";
  StudyStep["REVIEW_NOTE"] = "review-note";
  StudyStep["FIRST_REVIEW"] = "first-review";
  StudyStep["SECOND_REVIEW"] = "second-review";
  StudyStep["COMPLETED"] = "completed";
  StudyStep["DESCRIPTION"] = "description";
  return StudyStep;
}({});
export let AssignmentStudyPurpose = /*#__PURE__*/function (AssignmentStudyPurpose) {
  AssignmentStudyPurpose["MAIN_STUDY"] = "main-study";
  AssignmentStudyPurpose["FIRST_REVIEW"] = "first-review";
  AssignmentStudyPurpose["SECOND_REVIEW"] = "second-review";
  AssignmentStudyPurpose["DESCRIPTION"] = "description";
  return AssignmentStudyPurpose;
}({});
export let ProblemStatusType = /*#__PURE__*/function (ProblemStatusType) {
  ProblemStatusType["NORMAL"] = "NORMAL";
  ProblemStatusType["DESCRIPTION"] = "DESCRIPTION";
  return ProblemStatusType;
}({});
export let StudyItemType = /*#__PURE__*/function (StudyItemType) {
  StudyItemType["PROBLEM"] = "problem";
  StudyItemType["CONCEPT"] = "concept";
  StudyItemType["READING_MATERIALS"] = "reading-materials";
  StudyItemType["NO_CONTENT"] = "no-content";
  StudyItemType["NO_LECTURE_PROBLEM"] = "no-lecture-problem";
  return StudyItemType;
}({});
export let AnswerType = /*#__PURE__*/function (AnswerType) {
  AnswerType["CHOICE"] = "choice";
  AnswerType["MULTIPLE_CHOICE"] = "multiple-choice";
  AnswerType["SUBJECTIVE"] = "subjective";
  AnswerType["SUBJECTIVES_IN_ORDER"] = "subjectives-in-order";
  AnswerType["SUBJECTIVES_IN_NO_ORDER"] = "subjectives-in-no-order";
  AnswerType["DESCRIPTIVE"] = "descriptive";
  AnswerType["NOTE"] = "note";
  return AnswerType;
}({});
export let CanvasPencilWritingMethod = /*#__PURE__*/function (CanvasPencilWritingMethod) {
  CanvasPencilWritingMethod["PREMIUM"] = "premium";
  CanvasPencilWritingMethod["STANDARD"] = "standard";
  CanvasPencilWritingMethod["EXTENDED"] = "extended";
  return CanvasPencilWritingMethod;
}({});
export let CanvasPerformanceMode = /*#__PURE__*/function (CanvasPerformanceMode) {
  CanvasPerformanceMode["HIGH_PERFORMANCE"] = "highPerformance";
  CanvasPerformanceMode["LOW_PERFORMANCE"] = "lowPerformance";
  return CanvasPerformanceMode;
}({});
export let CanvasBrushColorValue = /*#__PURE__*/function (CanvasBrushColorValue) {
  CanvasBrushColorValue["BLACK"] = "black";
  CanvasBrushColorValue["RED"] = "red";
  CanvasBrushColorValue["BLUE"] = "blue";
  CanvasBrushColorValue["GREEN"] = "green";
  return CanvasBrushColorValue;
}({});
export let CanvasBrushColorCode = /*#__PURE__*/function (CanvasBrushColorCode) {
  CanvasBrushColorCode["BLACK"] = "#192029";
  CanvasBrushColorCode["RED"] = "#F64857";
  CanvasBrushColorCode["BLUE"] = "#1255EF";
  CanvasBrushColorCode["GREEN"] = "#00B268";
  return CanvasBrushColorCode;
}({});
export let CanvasBrushWidth = /*#__PURE__*/function (CanvasBrushWidth) {
  CanvasBrushWidth[CanvasBrushWidth["XXS"] = CANVAS_BRUSH_WIDTH_XXS] = "XXS";
  CanvasBrushWidth[CanvasBrushWidth["XS"] = CANVAS_BRUSH_WIDTH_XS] = "XS";
  CanvasBrushWidth[CanvasBrushWidth["S"] = CANVAS_BRUSH_WIDTH_S] = "S";
  CanvasBrushWidth[CanvasBrushWidth["M"] = CANVAS_BRUSH_WIDTH_M] = "M";
  CanvasBrushWidth[CanvasBrushWidth["L"] = CANVAS_BRUSH_WIDTH_L] = "L";
  return CanvasBrushWidth;
}({});
export let CanvasPixelEraserWidth = /*#__PURE__*/function (CanvasPixelEraserWidth) {
  CanvasPixelEraserWidth[CanvasPixelEraserWidth["S"] = CANVAS_PIXEL_ERASER_WIDTH_S] = "S";
  CanvasPixelEraserWidth[CanvasPixelEraserWidth["M"] = CANVAS_PIXEL_ERASER_WIDTH_M] = "M";
  CanvasPixelEraserWidth[CanvasPixelEraserWidth["L"] = CANVAS_PIXEL_ERASER_WIDTH_L] = "L";
  return CanvasPixelEraserWidth;
}({});
export let CanvasControllerBrushMode = /*#__PURE__*/function (CanvasControllerBrushMode) {
  CanvasControllerBrushMode["BRUSH"] = "brush";
  CanvasControllerBrushMode["ERASER"] = "eraser";
  return CanvasControllerBrushMode;
}({});
export let CanvasControllerEraserMode = /*#__PURE__*/function (CanvasControllerEraserMode) {
  CanvasControllerEraserMode["PIXEL_ERASER"] = "pixelEraser";
  CanvasControllerEraserMode["OBJECT_ERASER"] = "objectEraser";
  return CanvasControllerEraserMode;
}({});
export let CanvasLayerType = /*#__PURE__*/function (CanvasLayerType) {
  CanvasLayerType["STUDY"] = "STUDY";
  CanvasLayerType["FEEDBACK"] = "FEEDBACK";
  return CanvasLayerType;
}({});
export let ContainerTemplateType = /*#__PURE__*/function (ContainerTemplateType) {
  ContainerTemplateType["FULL_SCREEN_VIDEO"] = "FULL_SCREEN_VIDEO";
  ContainerTemplateType["FULL_SCREEN_CANVAS"] = "FULL_SCREEN_CANVAS";
  return ContainerTemplateType;
}({});